import {
  KnowledgePage,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import type { IEventEmitter } from '../EventEmitter';
import { WebSocketEventType } from '../WebSocketContext';

export function createKnowledgePageMessageHandler(eventEmitter: IEventEmitter) {
  return (action: WebSocketAction, item: KnowledgePage) => {
    try {
      switch (action) {
        case WebSocketAction.INSERT:
          log.debug(
            `[KnowledgePageHandler] INSERT KnowledgePage ${item.pageId}`,
          );
          eventEmitter.emit(
            WebSocketEntityType.KnowledgePage,
            WebSocketEventType.INSERT,
            item,
          );
          break;
        case WebSocketAction.MODIFY:
          log.debug(
            `[KnowledgePageHandler] MODIFY KnowledgePage ${item.pageId}`,
          );
          eventEmitter.emit(
            WebSocketEntityType.KnowledgePage,
            WebSocketEventType.MODIFY,
            item,
          );
          break;
        case WebSocketAction.REMOVE:
          log.debug(
            `[KnowledgePageHandler] REMOVE KnowledgePage ${item.pageId}`,
          );
          eventEmitter.emit(
            WebSocketEntityType.KnowledgePage,
            WebSocketEventType.REMOVE,
            item,
          );
          break;
        default:
          log.warn(
            '[KnowledgePageHandler] Unknown action for KnowledgePage:',
            action,
          );
      }
    } catch (error) {
      log.error('[KnowledgePageHandler] Handler failed:', error);
    }
  };
}
